module.exports = __webpack_public_path__ + "img/logo_confipetrol.379402ba.png";